import {ChangeDetectionStrategy, Component, computed, effect, ElementRef, input, viewChild} from '@angular/core';
import {Exemption, TaskMessageStatus} from "@portbase/bezoekschip-service-typescriptmodels";
import {
  DeclarationMessageStatus,
  VisitOverviewUtils
} from "../../visit-overview/visit-overview-item/visit-overview.utils";
import {isArray} from "lodash";
import {nonNull} from "../../../common/utils";

@Component({
    selector: 'app-status-indicator',
    templateUrl: './status-indicator.component.html',
    styleUrls: ['./status-indicator.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StatusIndicatorComponent {

  readonly summarizeIcon = input<boolean>();
  readonly exemptions = input<Exemption[]>([]);
  readonly messageStatus = input<TaskMessageStatus>();
  readonly showSummary = input<boolean>(true);
  readonly customCssClass = input<string>();
  readonly statusIndicatorButtonId = input<string>();
  readonly statusIndicatorSpanId = input<string>();
  readonly summarySize = input<'lg' | 'vlg' | 'xl'>('xl')
  readonly messageStatuses = input<DeclarationMessageStatus | DeclarationMessageStatus[]>();
  readonly showTooltip = input<boolean>(true);
  protected _messageStatuses: DeclarationMessageStatus[] = [];
  protected _messageStatus: TaskMessageStatus;

  readonly noDisplayClass = computed(() => `d-${this.summarySize()}-none`);
  readonly displayClass = computed(() => `d-${this.summarySize()}-inline-block`);

  readonly statusButton = viewChild<ElementRef>("statusButton");

  constructor() {
    effect(() => {
      const messageStatus = this.messageStatuses();
      this._messageStatuses = (isArray(messageStatus) ? messageStatus || [] : messageStatus ? [messageStatus] : []).filter(nonNull);
      this._messageStatus = this.messageStatus() || VisitOverviewUtils.getLeastTaskMessageStatus(this._messageStatuses);
    });
  }

  toggleElement = () => {
    this.statusButton()?.nativeElement?.click();
  }
}
